// footerData.js
import { Facebook, Twitter, Instagram, Linkedin, Dribbble } from "lucide-react";

export const FOOTER_SECTIONS = [
  {
    title: "Company",
    links: [
      { label: "About Us", href: "/about" },
      { label: "Privacy Policy", href: "/privacy-policy" }
    ],
  },
  {
    title: "Services",
    links: [
      { label: "Brand Strategy", href: "/services/brand-strategy-campaign-planning" },
      { label: "Social Media Management", href: "/services/social-media-management" },
      { label: "PR & Media Coverage", href: "/services/pr-media-coverage" },
      { label: "Corporate & Promotional Videos", href: "/services/corporate-promotional-videos" },
      { label: "Print Design & Brand Identity", href: "/services/print-design-brand-identity" },
      { label: "Event Management & On-Ground Activations", href: "/services/event-management-on-ground-activations" },
      { label: "Website Design & Web Development", href: "/services/website-design-web-development" },
      { label: "Software Development", href: "/services/software-development" },
    ],
  },
  {
    title: "Support",
    links: [{ label: "Contact Us", href: "/contact" }],
  },
];

export const SOCIAL_LINKS = [
  { icon: Facebook, href: "https://www.facebook.com/profile.php?id=61577099417057", label: "Facebook" },
  {
    icon: Instagram,
    href: "https://www.instagram.com/brand_focus_integrated?igsh=MXV5amZlZnV0cjM0aA==",
    label: "Instagram",
  },
  { icon: Linkedin, href: "https://www.linkedin.com/company/brand-focus-integrated/", label: "LinkedIn" },
];
